'use strict';

export default function($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/betausers", "/betausers/list");
  $stateProvider
    .state('betausers', {
      url: '/betausers',
      template: require('./betausers.html'),
      authenticate: true
    })
    .state('betausers.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'BetaUsersListController',
      controllerAs: 'betausersListCtrl'
    })
    .state('betausers.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'BetaUsersEditController',
      controllerAs: 'betausersEditCtrl'
    })
    .state('betausers.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'BetaUsersAddController',
      controllerAs: 'betausersAddCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/betausers/betausers.routes.js